const INITIAL_STATE = { navigateToWelcomePage: false };

const OmrBackButtonData = { INITIAL_STATE };

export default OmrBackButtonData;